(() => {
  if (customElements.get('motai-hero-carousel')) return;
  customElements.define('motai-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.russian = document.documentElement.lang.split('-')[0] === 'ru';
      if (this.russian) {
        this.setAttribute('aria-label', 'Фабрика MoTai');
        this.setAttribute('aria-roledescription', 'карусель');
        this.querySelector('[data-prev]').setAttribute('aria-label', 'Предыдущее изображение');
        this.querySelector('[data-next]').setAttribute('aria-label', 'Следующее изображение');
        this.querySelector('.motai-hero-dots').setAttribute('aria-label', 'Выбор изображения');
        this.dots.forEach((dot, i) => dot.setAttribute('aria-label', `Изображение ${i + 1} из ${this.slides.length}`));
      }
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered = false;
      const on = (target, event, callback) => target.addEventListener(event, callback, options);
      on(this.querySelector('[data-prev]'), 'click', () => this.show(this.index - 1, true));
      on(this.querySelector('[data-next]'), 'click', () => this.show(this.index + 1, true));
      this.dots.forEach((dot, index) => on(dot, 'click', () => this.show(index, true)));
      on(this.querySelector('[data-pause]'), 'click', () => {
        this.paused = !this.paused;
        this.updatePause();
        this.schedule();
      });
      on(this, 'focusin', () => this.schedule());
      on(this, 'focusout', () => setTimeout(() => { if (this.isConnected) this.schedule(); }, 0));
      on(document, 'visibilitychange', () => this.schedule());
      on(this, 'keydown', e => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        this.show(this.index + (e.key === 'ArrowRight' ? 1 : -1), true);
      });
      on(this.querySelector('.motai-hero-slides'), 'touchstart', e => { this.touchX = e.changedTouches[0].clientX; this.touchY = e.changedTouches[0].clientY; });
      on(this.querySelector('.motai-hero-slides'), 'touchend', e => {
        const dx = e.changedTouches[0].clientX - this.touchX;
        const dy = e.changedTouches[0].clientY - this.touchY;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1), true);
      });
      this.updatePause();
      this.schedule();
    }
    show(index, manual = false) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      if (manual) this.querySelector('[data-status]').textContent = this.russian ? `Изображение ${this.index + 1} из ${this.slides.length}` : `Image ${this.index + 1} of ${this.slides.length}`;
      this.schedule();
    }
    updatePause() {
      this.querySelector('[data-pause]').setAttribute('aria-label', this.russian ? (this.paused ? 'Запустить слайд-шоу' : 'Приостановить слайд-шоу') : (this.paused ? 'Play slideshow' : 'Pause slideshow'));
      this.querySelector('[data-pause-icon]').textContent = this.russian ? (this.paused ? 'Пуск' : 'Пауза') : (this.paused ? 'Play' : 'Pause');
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || document.hidden || this.contains(document.activeElement)) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 6000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
